export default "__VITE_ASSET__BjMEjddy__"